import React from "react";
import moment from "moment";
import _ from "lodash";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingButton from '@mui/lab/LoadingButton';
import MultipleSelect from "../widgets/MultiSelect";
import getFornitori from "../services/getFornitori";
import { InputAdornment, MenuItem, Stack, TextField } from "@mui/material";
import SettingsTitle from "../widgets/SettingsTitle";
import ManageRowSettings from "../widgets/ManageRowSettings";
import addOrdineFornitore from "../services/addOrdineFornitore";
import getFornitore from "../services/getFornitore";
import _default from "../themes/default";
import getProdottiFornitore from "../services/getProdottiFornitore";
import MultiSelectSearch from "../widgets/MultiSelectSearch";
import addFatturaProvvisoria from "../services/addFatturaProvvisoria";
import addReminder from "../services/addReminder";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

const rowTitle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 4,
    borderBottom: '0.3px solid #c1c1c1',
    marginTop: 30,
    marginBottom: 20
}

const groupInput = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 5
}

export default class AddOrdineFornitore extends React.Component {
    constructor(props){
        super (props)

        this.state = {
            fornitori:[],
            prodotti: [],
            fornitore: '',
            dataConsegna: '',
            selectedDisposizione: [],
        };

        this.disposizioni = [
            { value: 0, label: 'Immediato' },
            { value: 30, label: '30 GG.DF.FM.' },
            { value: 60, label: '60 GG.DF.FM.' },
            { value: 90, label: '90 GG.DF.FM.' },
            { value: 120, label: '120 GG.DF.FM.' },
            { value: 150, label: '150 GG.DF.FM.' },
            { value: 180, label: '180 GG.DF.FM.' }
        ];
    }

    async componentDidMount(){

        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });

        let prodottiList = await getProdottiFornitore(username, token, this.state.fornitori.id);
        this.baseProdotti = prodottiList;
        
        let res = await getFornitori(username, token);
        res.forEach((c,i) => {
            res[i].label = c.ragione_sociale
        })
        this.setState({fornitori: res, prodottiList})
    }

    async loadFornitore(id) {
        this.setState(() => ({ fornitore: null, prodotti: [] }), async () => {
            this.calcolaTotale();
            let fornitore = await getFornitore(username, token, id);
            let prodotti = await getProdottiFornitore(username, token, fornitore.id);
            let prodottiFornitore = fornitore.prodotti_custom ? JSON.parse(fornitore.prodotti_custom) : [];
            prodotti.forEach((p, i) => {
                let nuovoCosto = prodottiFornitore.find(prodotto => prodotto.prodottoId === p.id);
                if (nuovoCosto)
                    prodotti[i].prezzo = nuovoCosto.price;
            });
    
            this.setState({ 
                fornitore: id, 
                prodottiList: prodotti, 
                selectedDisposizione: fornitore.disposizione_pagamenti ? JSON.parse(fornitore.disposizione_pagamenti) : [],
            });
        });
    }

    addInput(param) {
        let obj = { id_prodotto: null, label: '', prezzo: '', quantita: null }
        let new_array = [...this.state[param], obj]
        this.setState({ [param]: new_array })
    }

    calcolaTotale(){
        let totale = 0;
        this.state.prodotti.forEach((prodotto)=> {
            totale += ( parseFloat(prodotto.prezzo) * parseInt(prodotto.quantita));
        })
        this.setState({totale: totale.toFixed(2)})
    }

    render () { 
        return (
        <>
            <PageTitle title={'Nuovo documento commerciale'} />  

            <Stack spacing={3} >
                <MultipleSelect fullWidth label={'Fornitore'} oneSelected names={this.state.fornitori} single onChangeListener={(fornitore)=> this.loadFornitore(fornitore)} sel={this.state.fornitore} />
                <TextField value={this.state.rif} variant="outlined" label={'Riferimento'} onChange={(e) => { this.setState({rif: e.target.value})}} />
                <TextField fullWidth multiline rows={4} variant="outlined" label={'Descrizione'} value={this.state.descrizione} 
                    onChange={(e) => { this.setState({descrizione: e.target.value})}
                } />
            </Stack>

            { this.state.fornitore && (
            <>
                <Stack spacing={3} sx={{flex: 1}}>
                    <div style={rowTitle}>
                        <SettingsTitle title="Prodotti" />
                        <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInput('prodotti')}/>
                    </div>
                    <div>
                        {   
                            this.state.prodotti.map((el, i) => {
                                return (
                                <div key={i} style={groupInput}>
                                    <Stack direction={"row"} spacing={1} sx={{flex:1}} >
                                        <TextField
                                            fullWidth
                                            select
                                            value={el.label}
                                            label="Prodotto"
                                            onChange={(e)=> {
                                                let arr = [...this.state.prodotti]
                                                arr[i].label = e.target.value;
                                                arr[i].prezzo = this.state.prodottiList.find((n) => n.nome === e.target.value).prezzo;
                                                arr[i].id_prodotto = this.state.prodottiList.find((n) => n.nome === e.target.value).id;
                                                arr[i].quantita = 1;
                                                this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                            }}
                                        >
                                            {
                                                this.state.prodottiList.map((prodotto, i) => {
                                                    return(
                                                        <MenuItem key={i} value={prodotto.nome}>{prodotto.nome}</MenuItem>
                                                    )
                                                })
                                            }
                                        </TextField>
                                        <TextField  
                                            InputLabelProps={{shrink: el.quantita}}
                                            type="number"
                                            variant="outlined" 
                                            label={'Quantita'} value={el.quantita} 
                                            onChange={(e) => {
                                            let arr = this.state.prodotti
                                            arr[i].quantita = e.target.value
                                            this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                        }}/> 
                                        <TextField  
                                            InputProps={{endAdornment: <InputAdornment position="end">€</InputAdornment>,}}
                                            type="number"
                                            variant="outlined" 
                                            label={'Prezzo Unit'} value={el.prezzo} 
                                            onChange={(e) => {
                                            let arr = this.state.prodotti
                                            arr[i].prezzo = e.target.value
                                            this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                        }}/> 
                                        <ManageRowSettings
                                            callback={() => {
                                                let updated = this.state.prodotti.filter((e, index) => index !== i)
                                                this.setState(() => ({ prodotti: updated }), () => {
                                                    this.calcolaTotale();
                                                })
                                            }}
                                        />
                                    </Stack>
                                </div>
                                )
                            })
                        }
                    </div>
                </Stack>
                <Stack spacing={3}>
                    <TextField InputProps={{readOnly:true, endAdornment: <InputAdornment position="end">€</InputAdornment>,}} sx={{mt:3}} variant="outlined" label="Totale" value={this.state.totale} InputLabelProps={{shrink: this.state.totale}} 
                        onChange={(e) => { this.setState({totale: e.target.value})}
                    } />
                </Stack>
                <div style={{ height: 30 }}></div>

                <Stack direction={"row"} spacing={1} sx={{flex:1}} >
                    <TextField
                        sx={{flex:1}}
                        type="date"
                        value={this.state.dataConsegna}
                        label="Data di consegna"
                        onChange={(e)=> {
                            this.setState({dataConsegna: e.target.value});
                        }}
                        InputLabelProps={{shrink: true}}
                    />
                    <Stack sx={{flex:1}}>
                        <MultiSelectSearch optionsArray={this.disposizioni} labelKey={'label'} label='Disposizioni pagamento' selectedValues={this.state.selectedDisposizione} onSelected={(e) => { this.setState({ selectedDisposizione: e })}} />
                    </Stack>
                </Stack>
                <div style={{ height: 30 }}></div>
                <LoadingButton fullWidth sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.save()}>Salva</LoadingButton>
            </>
            )}    
        </>
        );
    }

    async save() {

        if (!this.state.fornitore) {
            alert('Inserire un fornitore valido');
            return;
        }
        
        if (!this.state.descrizione) {
            alert('Inserire una descrizione valida');
            return;
        }

        if (this.state.prodotti.length === 0) {
            alert('Inserire un prodotto');
            return;
        }

        if (!this.state.totale) {
            alert('Inserire un totale valido');
            return;
        }

        if(!this.state.dataConsegna) {
            alert('Inserire una data di consegna valida');
            return;
        }

        if(this.state.selectedDisposizione.length === 0) {
            alert('Inserire una disposizione di pagamento');
            return;
        }

        this.setState({ isLoading: true });

        let ordineFornitore = {
            fornitore: this.state.fornitore, 
            descrizione: this.state.descrizione, 
            prodotti: JSON.stringify(this.state.prodotti), 
            totale: this.state.totale, 
            data_consegna: this.state.dataConsegna,
            disposizioni: JSON.stringify(this.state.selectedDisposizione),
            rif: this.state.rif
        };

        let res = await addOrdineFornitore(username, token, ordineFornitore);
        if (res.result === 'ok') {
            var date_disposizioni = [];
            let singolaRata = parseFloat(this.state.totale)/this.state.selectedDisposizione.length;
            var dataFattura = moment();
            this.state.selectedDisposizione.forEach(d => {
                var data = '';
                if (d.value === 0) {
                    data = dataFattura.format('DD/MM/yyyy');
                } else {
                    data = moment(dataFattura, 'DD/MM/yyyy')
                    data = data.add(d.value, 'days');
                    data = data.endOf('month').format('DD/MM/yyyy');
                }
                date_disposizioni.push({ data: data, importo: singolaRata });
            });
            date_disposizioni = date_disposizioni.sort((a, b) => {
                return moment(a.data, 'DD/MM/yyyy').isBefore(b.data, 'DD/MM/yyyy') ? -1 : 1
            });

            let ragione_sociale = this.state.fornitori.find(f => f.id === this.state.fornitore[0]).ragione_sociale;

            let r = await addFatturaProvvisoria(username, token, {
                ragione_sociale,
                'rif': res.rif,
                'importo': this.state.totale,
                'disposizioni': this.state.selectedDisposizione,
                'date_disposizioni': date_disposizioni,
            });
        }

        if (res.result === 'ok') {
            addReminder(username, token, 'Aggiunto ordine fornitore ' + res.rif, 'amministrazione', 'notifica ordine fornitore', res.id);
            cookies.set('ordineFornitore', res.id, { path: '/' });
            window.location.href = '#/service/edit-ordine-fornitore';
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la creazione dell\'ordine. Per favore, riprova.');
    }

}
